import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";

export default class extends Controller {
    static targets = ["form"];

    connect() {
        this.validator = new JustValidate(this.formTarget, {
            validateBeforeSubmitting: true,
        });

        this.validator
            .addField('[name="address1"]', [
                {
                    rule: "required",
                    errorMessage: "Address 1 is required",
                },
            ])
            .addField('[name="state"]', [
                {
                    rule: "required",
                    errorMessage: "State is required",
                },
            ])
            .addField('[name="city"]', [
                {
                    rule: "required",
                    errorMessage: "City is required",
                },
            ])
            .addField('[name="zip"]', [
                {
                    rule: "required",
                    errorMessage: "Zip code is required",
                },
                {
                    rule: "number",
                    errorMessage: "Zip code must be a number",
                },
            ]);
    }
}